module.exports = __webpack_public_path__ + "img/homepage_0@3x.8059f935.jpg";